export const codes = ['PSKIN01', 'PSKIN02']
